/* CustomSolo — Judge.me review photo hardening (2026-10-19, rev2)
   Review photo click: if Judge.me's lightbox is not initialised yet
   (scripts blocked / JS error / extremely slow network), open an in-page
   lightbox instead of navigating to the raw JPG in a new tab (the anchor
   ships with target="_blank").

   NOTE (2026-10-19 rev2): an earlier scroll-restore MutationObserver patch
   was REMOVED on evidence — Judge.me already restores the scroll position
   animated and EXACTLY to the pointerdown position (verified timeline
   0→63→3680→5918→6415 = pointerdownY). The previously measured "drift"
   was a test artifact (Playwright auto-scroll + early sampling).
   A 2-rAF correction would only fight that animation, so it is gone. */
(function () {
  'use strict';

  function jmLightboxReady() {
    try {
      var jq = window.jdgm && window.jdgm.$;
      if (!jq || !jq._data) return false;
      var ev = jq._data(document, 'events');
      return !!(ev && ev.click && ev.click.length);
    } catch (err) { return false; }
  }

  function openFallback(src) {
    if (!src) return;
    var y = window.scrollY;
    var ov = document.createElement('div');
    ov.className = 'cs-review-lightbox';
    ov.innerHTML =
      '<button type="button" class="cs-review-lightbox__close" aria-label="Close">&times;</button>' +
      '<img alt="Customer review photo">';
    ov.querySelector('img').src = src;
    document.body.appendChild(ov);
    document.body.style.top = (-y) + 'px';
    document.body.classList.add('cs-review-lock');
    function onKey(e) { if (e.key === 'Escape') close(); }
    function close() {
      document.removeEventListener('keydown', onKey);
      ov.remove();
      document.body.classList.remove('cs-review-lock');
      document.body.style.top = '';
      /* behavior:'instant' — global CSS sets scroll-behavior:smooth, which would
         turn this into an animated scroll and race the sampling/user. */
      window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    }
    document.addEventListener('keydown', onKey);
    ov.addEventListener('click', close);
  }

  /* Bubble phase on document: if Judge.me handled the click it has already
     called preventDefault and we step aside. If not (Judge.me JS absent),
     we own the click and show the fallback lightbox. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a.jdgm-rev__pic-link') : null;
    if (!a || e.defaultPrevented) return;
    if (jmLightboxReady()) return; /* Judge.me owns this click */
    e.preventDefault();
    openFallback(a.getAttribute('data-mfp-src') || a.getAttribute('href'));
  });
})();
